import React from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material';

const Icon = styled('span')(({ theme }) => ({
  borderRadius: 4,
  width: 20,
  height: 20,
  border: `1px solid ${theme.palette.gray500}`,
  'input:hover ~ &': {
    borderColor: '#03e1b9',
  },
}));

const StyledLabel = styled(FormControlLabel)(({ theme }) => ({
  '.MuiFormControlLabel-label': {
    fontSize: 14,
    userSelect: 'none',
    color: theme.palette.tertiary.main,
    '&.Mui-disabled': {
      color: theme.palette.tertiary.light,
    },
  },
}));

const CheckedIcon = styled(Icon)({
  borderColor: '#03e1b9',
  background:
    "#03e1b9 url(\"data:image/svg+xml,%3Csvg fill='none' width='10' height='10' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.75 2 3.5 8 1.25 5.75' stroke='%23fff' stroke-linecap='square' stroke-width='1.5'/%3E%3C/svg%3E\") center center",
  backgroundRepeat: 'no-repeat',
});

function CheckboxWithLabel({ checked, onChange, label, disabled }) {
  return (
    <FormGroup>
      <StyledLabel
        control={
          <Checkbox
            disableRipple
            disabled={disabled}
            checked={checked}
            onChange={onChange}
            icon={<Icon />}
            checkedIcon={<CheckedIcon />}
          />
        }
        label={label}
      />
    </FormGroup>
  );
}

export default CheckboxWithLabel;
